export default {
    ja: {
        general: {
            image_webp: ".webp",
            alt: "のロゴ",
            menu: "MENU",
            tel: "TEL",
            fax: "FAX",
            sns: "FOLLOW ME",
            scroll: "SCROLL",
            page_top: "Page Top",
            required: "必須",
            any: "任意",
            rss: "BLOG"
        },
        page: {
            alt: "ページのカバーイメージ",
            news_button: "お知らせ一覧",
            rss_button: "RSSフィード",
        },
        contact: {
            business_company: "会社名",
            customer_company: "会社名（法人の方）",
            company_warning: "※法人の方のみご入力ください。",
            basic_name: "お名前",
            business_name: "担当者名",
            tel: "電話番号",
            email: "メールアドレス",
            message: "お問い合わせ内容",
            method: {
                text: "ご連絡方法",
                list: [
                    {
                        id: 1,
                        name: "お電話",
                        value: "tel"
                    },
                    {
                        id: 2,
                        name: "メール",
                        value: "email"
                    },
                    {
                        id: 3,
                        name: "どちらでもよい",
                        value: "noselect"
                    }
                ],
                warning: "※お電話での回答を希望の方は、必ず電話番号をご入力ください。"
            },
            title: "件名",
            warning: "お客様の個人情報は、個人情報に関して適用される法令規範を遵守するとともに、\r\nお問い合わせ内容や貴重なご意見は今後の業務の改善並びに参考とさせていただきます。",
            privacy_link: "プライバシーポリシー",
            privacy_text: "をご一読ください。",
            agreement: "プライバシーポリシーに同意します。",
            send_text: "お問い合わせいただきありがとうございます。\r\nメールの送信が完了いたしました。\r\n\r\n内容を確認の上ご連絡をいたしますので、お待ちください。",
            send_error: "フォームが送信できませんでした。\r\n\r\n恐れ入りますが、お時間をおいて再度ご入力の上、送信をお試しください。\r\nご不便おかけして申し訳ございません。",
            send_invalid: "入力に誤りがあります。\r\n入力内容をご確認の上、再度送信をお試しください。",
            button: "入力内容を送信"
        },
        news: {
            null_title: "表示する記事はありません。",
            null_summary: "現在、投稿されている記事はありません。",
            top_button: "トップページに戻る",
            list_button: "一覧に戻る",
            new_label: "New!!",
            alt: "のサムネイル",
            all_category: "すべて",
            archive: "年別アーカイブ",
            year: "年",
        },
        download: {
            null_title: "表示するダウンロードはありません。",
            null_summary: "現在、ダウンロードいただけるデータはありません。",
            top_button: "トップページに戻る",
            list_button: "一覧に戻る",
            message: "日頃のご愛顧のいただいている皆さまをはじめ、当初に初めてご来店される皆さまが\r\nお得にご利用いただけるクーポンを発行しております。",
            alt: "のサムネイル",
            button: "PDFをダウンロード"
        },
        coupon: {
            null_title: "表示するクーポンはありません。",
            null_summary: "現在、ご利用いただけるクーポンはありません。",
            top_button: "トップページに戻る",
            list_button: "一覧に戻る",
            message: "日頃のご愛顧のいただいている皆さまをはじめ、当初に初めてご来店される皆さまが\r\nお得にご利用いただけるクーポンを発行しております。",
            do_action: "お手持ちのスマートフォンもしくはタブレットでご利用ください。",
            alt: "のクーポン画像",
            limit: "有効期限",
            limit_none: "有効期限なし",
            limit_over: "有効期限切れのため、現在ご利用いただけません。",
            button: "クーポンを使う",
            modal_lead: "表示されるクーポン画面を\r\n会計時にレジのスタッフへご提示ください。\r\n今すぐ使用しますか？",
            modal_summary: "「はい」をクリックすると使用できます。\r\nお手持ちのスマートフォンかタブレットでご利用ください。\r\nクーポンは何度でもご利用いただけます。",
            used: "使用済み",
            open: "はい",
            close: "いいえ",
        },
        research: {
            recommend_title: "当店をご家族、ご友人の方に勧めたいと思いますか？",
            answer_title: "差し支えなければ、お客様について教えてください。お答えいただける範囲でかまいません。",
            think: "思う",
            no_think: "思わない",
            no_select: "回答しない",
            gender: {
                text: "性別",
                list: [{
                        id: 1,
                        name: "男性"
                    },
                    {
                        id: 2,
                        name: "女性"
                    },
                ],
            },
            age: {
                text: "年齢",
                list: [{
                        id: 10,
                        name: "10代"
                    },
                    {
                        id: 20,
                        name: "20代"
                    },
                    {
                        id: 30,
                        name: "30代"
                    },
                    {
                        id: 40,
                        name: "40代"
                    },
                    {
                        id: 50,
                        name: "50代"
                    },
                    {
                        id: 60,
                        name: "60代"
                    },
                    {
                        id: 70,
                        name: "70代以上"
                    },
                ],
            },
            occupation: {
                text: "所属",
                list: [{
                        id: 1,
                        name: "学生"
                    },
                    {
                        id: 2,
                        name: "アルバイト"
                    },
                    {
                        id: 3,
                        name: "社会人"
                    },
                    {
                        id: 9,
                        name: "その他"
                    },
                ],
            },
            can_contact: {
                text: "お寄せいただいた内容によっては、後日、ご連絡をさせていただく可能性がございますが、\r\nご連絡をさせていただいてもよろしいでしょうか？",
                list: [{
                        id: 1,
                        name: "はい"
                    },
                    {
                        id: 2,
                        name: "いいえ"
                    },
                ],
            },
            name: "お名前",
            tel: "電話番号",
            email: "メールアドレス",
            message: "当店へのご意見・ご要望をお聞かせください。",
            msg_placeholder: "ご自由にご入力ください",
            privacy_link: "プライバシーポリシー",
            privacy_text: "をご一読ください。",
            agreement: "プライバシーポリシーに同意します。",
            button: "入力内容を送信",
            send_text: "ご回答いただきありがとうございます。\r\n\r\nお客様の個人情報は、個人情報に関して適用される法令規範を遵守するとともに、\r\n貴重なご意見は今後の業務の改善並びに参考とさせていただきます。",
            send_error: "アンケートが送信できませんでした。\r\n\r\n恐れ入りますが、お時間をおいて再度ご入力の上、送信をお試しください。\r\nご不便おかけして申し訳ございません。",
            send_invalid: "入力に誤りがあります。\r\n入力内容をご確認の上、再度送信をお試しください。",
        },
        system: {
            closed: {
                title: "非公開",
                lead: "アクセスしようとしたページは表示できませんでした。",
                summary: 'お客様には大変ご迷惑をおかけしますが、\r\n当サイトはただいま非公開となっております。',
            },
            error: {
                500: "500",
                503: "503",
                lead: "アクセスしようとしたページは表示できませんでした。",
                summary: '内部参照におけるエラーのため、\r\n目的のページが表示できなかったことを意味します。',
            },
            page403: {
                status: "403",
                lead: "アクセスしようとしたページは表示できませんでした。",
                summary: "このエラーは、表示するページへのアクセス許可がなかったことを意味します。",
            },
            page404: {
                status: "404",
                lead: "お探しのページがありません。",
                summary: 'お探しのページは一時的にアクセスできない状況にあるか、\r\n移動もしくは削除された可能性があります。',
            },
            button: "トップページに戻る"
        },
        color: [
            {
                id: 1,
                name: "メレンゲ",
                code: "merenge"
            },
            {
                id: 2,
                name: "コーヒー",
                code: "coffee"
            },
            {
                id: 3,
                name: "ラズベリー",
                code: "raspberry"
            },
            {
                id: 4,
                name: "モカ",
                code: "mocha"
            },
            {
                id: 5,
                name: "アボカド",
                code: "avocado"
            },
        ]
    },
};